import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "../../Components/Button/Button";
import BlogFilterSlider from "../../Components/FilterSlider/BlogsFilter/BlogsFilter.js";
import Cookies from "js-cookie";

import {
  blogData,
  clearBlogSliceStates,
  clearBlogSliceData,
  clearBlogDetailData,
  clearBlogUserData,
  clearBlogSliceMessages,
} from "../../redux/blogs/blogSlice";
import "./UserBlogs.css";
import "../AllBlogs/TableStyle.css";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  getAllBlogs,
  getBlogById,
  deleteBlog,
  updateBlog,
  makeBlogActiveInactive,
  getBlogsByUserId,
  duplicateBlog,
} from "../../redux/blogs/blogSlice";
import DropActions from "../../Components/DropActions/DropActions.jsx";
import Image from "../../Components/Image/Image";
import LogoutPopup from "../../Components/Popups/LogoutPopup/LogoutPopup.jsx";
import BlogDashboardMenu from "../../Layouts/Menu/BlogDashboardManagement/BlogDashboardMenu.js";
import EditBlogPopup from "../../Components/Popups/EditBlogPopup/EditBlogPopup.jsx";
import ComponentLoader from "../../Components/loaders/ComponentLoader/ComponentLoader.jsx";
import BlogPreview from "../../Components/Popups/BlogPreview/BlogPreviewPopup.js";
import CustomDropdown from "../../Components/CustomDropdown/CustomDropdown.jsx"
const UserBlogs = () => {
  const {
    isBlogSliceFetching,
    isBlogSliceFetchingSmall,
    isBlogSliceSuccess,
    isBlogSliceError,
    blogSliceErrorMessage,
    blogSliceSuccessMessage,
    isBlogEditSliceSuccess,
    isBlogDeleteSliceSuccess,
    isBlogActiveInactiveSuccess,
    isBlogByUserFetching,
    UserBlogs,
    blogCount,
    blogDetail,
    totalUserBlogs,
  } = useSelector((state) => state.blog);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedBlogId, setSelectedBlogId] = useState([]);
  const [selectedBlog, setSelectedBlog] = useState([]);
  const [isDropAction, setIsDropAction] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [editBlogPopup, setEditBlogPopup] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [previewPopup,setPreviewPopup]=useState(false);
  const [statusPopup,setStatusPopup]=useState(false)
  const [blogId, setBlogId] = useState(null);
  const data = Cookies.get('loginData')
      ? JSON.parse(Cookies.get('loginData'))
      : null

  
  const [isPerPageDrop, setIsPerPageDrop] = useState(false);
  const [perPageDropName, setPerPageDropName] = useState(10);
  
  const [isFilterSlider, setIsFilterSlider] = useState(false);
  const intialFilter = {
    statusType:"all",
    fromDate:moment("2019-01-01").format("YYYY-MM-DD"),
    toDate:moment().format("YYYY-MM-DD"),
  
    blogType:""
  }
   const [filters, setFilters] = useState(intialFilter);
  const toggleActionDropdown = (rowId, blog) => {
    setIsDropAction(isDropAction === rowId ? false : rowId);
    setSelectedBlogId(rowId);
    setSelectedBlog(blog);
    setBlogId(blog?.id)
  };

  const dropActionOptions = [
    { label: "Delete Blog", onClick: () => setDeletePopup(true) },
    {
      label: "Edit Blog",
      onClick: () => {
        setEditBlogPopup(true);
      },
    },
    {
      label: "Preview Blog",
      onClick: () => {
        // setPreviewPopup(true);
        navigate(`/blog-details?id=${blogId}`);
      },
    },
    {
      label: "Change Status",
      onClick: () => setStatusPopup(true)
    },
    // {
    //   label: "Duplicate Blog", // New option for duplicating a blog
    //   onClick: () => {
    //     handleDuplicate(selectedBlogId);
    //   },
    // }
    
  ];

  const BlogsRightMenuoption=[
    () => (
      <CustomDropdown
        className={"current"}
        dropName={perPageDropName}
        options={[
          { name: "10", id: 10 },
          { name: "20", id: 20 },
          { name: "30", id: 30 },
          { name: "40", id: 40 },
          { name: "50", id: 50 },
          { name: "Max", id: totalUserBlogs },
        ]}
        isActive={isPerPageDrop}
        setIsActive={setIsPerPageDrop}
        onSelect={onChangePerPage}
      />
    ),
    ()=>(
      <Button
          className={"iconButton"}
          src={"https://cdn.mastersunion.org/assets/dinero/filter.svg"}
          name={"Filters"}
          onClick={() => {
            setIsFilterSlider(!isFilterSlider);
          } } />)
      ]
  const BlogSearchHandler = (searchValue) => {
    const keywords = searchValue.split(",").map((keyword) => keyword.trim());
    setCurrentPage(1);
    setSearchQuery(keywords);
  };

  const clearSearch = () => {
    setSearchQuery("");
    setCurrentPage(1);
  };

  const handleDelete = (blogId) => {
    console.log("del", blogId);
    let obj = {
      id: selectedBlogId,
      userId : data ? data.id : ""
    };
    dispatch(deleteBlog(obj));
  };
  const handleEditPopup = (obj) => {
    console.log("edit", obj);
    dispatch(updateBlog(obj));
  };
  const handleDuplicate = (blogId) => {
    console.log("Duplicate blog with ID:", blogId);
    let obj={
      blogId:blogId
    }
    dispatch(duplicateBlog(obj));
  };
  const readMore = (id) => {
    console.log("id", id);
    navigate(`/blog-details?id=${id}`);
    navigate(`/blog-details?id=${id}`);
  };

  useEffect(() => {
    let obj = {
      searchValue: searchQuery,
      pageNumber: currentPage,
      perPageCount: perPageDropName,
      filters:filters
    };
    dispatch(getBlogsByUserId(obj));
    return () => {
      dispatch(clearBlogUserData());
      dispatch(clearBlogSliceMessages());
      dispatch(clearBlogSliceStates())
    };
  }, [searchQuery,filters,perPageDropName]);

  const successToast = () => {
    toast.success(blogSliceSuccessMessage, {
      // position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 3000, // Close the toast after 3 seconds
      hideProgressBar: false, // Display progress bar
      pauseOnHover: true, // Pause the timer when hovering over the toast
    });
  };

  const errorToast = () => {
    toast.error(blogSliceErrorMessage, {
      // position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 3000, // Close the toast after 3 seconds
      hideProgressBar: false, // Display progress bar
      pauseOnHover: true, // Pause the timer when hovering over the toast
    });
  };

  const onChangePerPage = (obj) => {
    setPerPageDropName(obj.id);
    // setIsAllChecked(false);
    // setSelectedApplicants([]);
  };
  
  const loadMore = () => {
    dispatch(
      getBlogsByUserId({
        perPageCount: perPageDropName,
        pageNumber: currentPage + 1,
        searchValue: searchQuery,
        filters:filters
      })
    );
   
  };
  const handleStatus= (blogId,status) => {
    console.log("status", blogId,status);
    let obj = {
      id: selectedBlogId,
      status: !selectedBlog?.blog_isActive,
      userId : data ? data.id : ""

    };
    dispatch(makeBlogActiveInactive(obj));
  };
  useEffect(() => {
    if (isBlogSliceSuccess) {
      successToast();
      setDeletePopup(false);
      setEditBlogPopup(false);
    }
  }, [isBlogSliceSuccess]);
  
useEffect(()=>{
  if(isBlogEditSliceSuccess){
    successToast();
    setEditBlogPopup(false);
  }
  return()=>{
    dispatch(clearBlogSliceStates())
  }
},[isBlogEditSliceSuccess])
useEffect(() => {
  if (isBlogDeleteSliceSuccess) {
    successToast();
    setDeletePopup(false);
    // setEditBlogPopup(false);
  }
  return()=>{
    dispatch(clearBlogSliceStates())
  }
}, [isBlogDeleteSliceSuccess]);
useEffect(() => {
  if (isBlogActiveInactiveSuccess) {
    successToast();
   setStatusPopup(false)
    // setEditBlogPopup(false);
  }
  return()=>{
    dispatch(clearBlogSliceStates())
  }
}, [isBlogActiveInactiveSuccess]);
useEffect(()=>{
  if(isBlogEditSliceSuccess){
    successToast();
    setEditBlogPopup(false);
  }
  return()=>{
    dispatch(clearBlogSliceStates())
  }
},[isBlogEditSliceSuccess])
useEffect(() => {
  if (isBlogDeleteSliceSuccess) {
    successToast();
    setDeletePopup(false);
    // setEditBlogPopup(false);
  }
  return()=>{
    dispatch(clearBlogSliceStates())
  }
}, [isBlogDeleteSliceSuccess]);
useEffect(() => {
  if (isBlogActiveInactiveSuccess) {
    successToast();
   setStatusPopup(false)
    // setEditBlogPopup(false);
  }
  return()=>{
    dispatch(clearBlogSliceStates())
  }
}, [isBlogActiveInactiveSuccess]);
  useEffect(() => {
    if (isBlogSliceError) {
      errorToast();
    }
  }, [isBlogSliceError]);
  return (
    <>
      <ToastContainer />
      <BlogFilterSlider
        isActive={isFilterSlider}
        setIsActive={setIsFilterSlider}
        setFilters={setFilters}
      />
      {deletePopup && (
        <LogoutPopup
          showActive={deletePopup}
          userId={selectedBlogId}
          message={"Are you sure you want to delete this blog?"}
          onCancel={() => setDeletePopup(false)}
          onAllow={handleDelete}
          isPopupFetching={isBlogSliceFetchingSmall}
        />
      )}
      {statusPopup && (
        <LogoutPopup
          showActive={statusPopup}
          userId={selectedBlogId}
          message={"Are you sure  change status of Blog?"}
          onCancel={() => setStatusPopup(false)}
           onAllow={handleStatus}
  
          isPopupFetching={isBlogSliceFetchingSmall}
        />
      )}
      {previewPopup && (
        <BlogPreview
          isActive={previewPopup}
          onClickClosePopup={() => setPreviewPopup(false)}
          blogId={selectedBlogId}
          blogDetails={selectedBlog}
          // onSubmit={handleEditPopup}         
          isEditTemplatePopupFetching={isBlogSliceFetchingSmall}
        />
      )}
      {editBlogPopup && (
        <EditBlogPopup
          isActive={editBlogPopup}
          onClickClosePopup={() => setEditBlogPopup(false)}
          blogId={selectedBlogId}
          blogDetails={selectedBlog}
          onSubmit={handleEditPopup}
          isEditTemplatePopupFetching={isBlogSliceFetchingSmall}
        />
      )}
      <BlogDashboardMenu
        searchFunction={BlogSearchHandler}
        clearSearch={clearSearch}
        currentCount={UserBlogs?.length}
        // totalCount={totalUserBlogs && totalUserBlogs}
        BlogsRightMenuoption={BlogsRightMenuoption}
        totalCount={totalUserBlogs && totalUserBlogs}
        onClickCreateBlog={()=>navigate(`/create-blog`)}
      />
      <div className="wrapperBox singleMenu">
        {isBlogByUserFetching && <ComponentLoader />}
        <div className="tableWrapper wrapWithButton checkboxTable noIconTable actionFix">
          <table className="darkHeaderTable">
            <thead>
              <tr>
                <th>
                  <div className="tableHeading">
                    <img src="/assets/svg/teacher.svg" alt="" />
                    My Blog Image
                  </div>
                </th>
                <th>
                  <div className="tableHeading">
                    <img src="/assets/svg/user.svg" alt="" />
                    Blog Title
                  </div>
                </th>
                <th>
                  <div className="tableHeading">
                    <img src="/assets/svg/user.svg" alt="" />
                    Blog Description
                  </div>
                </th>
                <th>
                  <div className="tableHeading">
                    <img src="/assets/svg/user.svg" alt="" />
                    Blog Type
                  </div>
                </th>
                <th>
                  <div className="tableHeading">
                    <img src="/assets/svg/user.svg" alt="" />
                    Blog Tags
                  </div>
                </th>
                <th>
                  <div className="tableHeading">
                    <img src="/assets/svg/user.svg" alt="" />
                    Status
                  </div>
                </th>
                <th>
                  <div className="tableHeading">
                    <img src="/assets/svg/user.svg" alt="" />
                    Created On
                  </div>
                </th>

                <th>
                  <div className="tableHeading">
                    <img src="/assets/svg/user.svg" alt="" />
                    Action
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {UserBlogs?.map((blog, index) => (
                <tr key={blog?.id}>
                  <td>
                    <div className="tableData">
                      <img
                        src={blog.smallImage}
                        alt={blog.blog_Title}
                        style={{ width: "100px" }}
                      />
                    </div>
                  </td>
                  <td>
                    <div
                      className="tableData pointer"
                      onClick={() => {
                        navigate(`/blog-details?id=${blog?.id}`);
                        navigate(`/blog-details?id=${blog?.id}`);
                      }}
                    >
                      {blog.blog_Title}
                    </div>
                  </td>
                  <td>
                    {/* <div className="tableData">{blog.blog_description}</div> */}
                    {blog.blog_description.split(" ").slice(0, 6).join(" ")}
                    {blog.blog_description.split(" ").length > 6 ? "..." : ""}
                  </td>
                  <td>
                    <div className="tableData">{blog?.blog_Type}</div>
                  </td>
                  <td>
                    <div className="tableData">{blog?.tags?.join(", ")}</div>
                  </td>
                  <td>
                  <div className="tableData"> {blog?.blog_isActive ? "Active" : "InActive"}</div>
                  </td>
                  <td>
                    <div className="tableData">
                      {moment(blog.blog_CreatedOn).format("MMM DD YYYY")}
                    </div>
                  </td>

                  <td>
                    <div
                      className="tableData"
                      onClick={() => toggleActionDropdown(blog?.id, blog)}
                    >
                      <img
                        className="settingIcon"
                        src="https://cdn.mastersunion.org/assets/dinero/setting.svg"
                      />
                      <DropActions
                        isActive={isDropAction === blog?.id}
                        dropActionOptions={dropActionOptions}
                        blogId={blog?.id}
                      />
                    </div>
                  </td>
                </tr>
              ))}
              {UserBlogs?.length !== totalUserBlogs && (
          <div className="loadMoreWrapper">
            <Button
              isWaiting={
                UserBlogs?.length > 0 &&
                isBlogSliceFetching
              }
              onClick={loadMore}
              className={"BlueFillButton"}
              name={"Load More"}
            />
          </div>
        )}
              {UserBlogs?.length === 0 && !isBlogSliceFetching && (
                <tr>
                  <td colSpan={"11"}>
                    <span className="noData">
                      <img
                        src={
                          "https://cdn.mastersunion.org/assets/imgV2/noDataDineroNew2.png"
                        }
                        alt=""
                      />
                    </span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
     
    </>
  );
};

export default UserBlogs;
